module.exports = __webpack_public_path__ + "img/w18-cover.bb085d94.jpg";